<template lang="pug">
div
  .box.branded-box
    h4.title.is-5 {{$t('services.details.addon_products_label')}}
    p.subtitle.is-6(v-t="'inventory.product_type.consumable_is_addon_description'")
    table.table.is-fullwidth
      thead
        tr
          th(v-t="'services.details.addon_product'" style="width: 50%")
          //th.has-text-centered Fixed
          th.has-text-centered(v-t="'misc.required'")
          th(v-t="''")
          //th Price
          th 
      tbody
        tr(v-if="addons.length === 0")
          td.has-text-centered(colspan="4") {{$t('services.details.no_addons')}}
        tr.is-vertically-centered(v-for="addon in addons" :key="addon.product")
          td
            ProductView(:productId="addon.product" :sku="true" price)
          td.has-text-centered
            b-checkbox(v-model="addon.required" @input="update")
          //- td.has-text-right
          //-   currency-view()
          td
            b-field
              b-input(v-model="addon.defaultQty" @input="update")
              p.control
                ProductUnitLabel.button.is-static(:product="addon.product")
                
          td
            a(@click="remove(addon)") 
              span.icon
                i.mdi.mdi-trash-can-outline.mdi-24px
      tfoot(v-if="addons.length > 0")
        tr
          td.has-text-right(colspan="4") 
            span(v-t="'services.addons_label'")  
            |  
            currency-view.has-text-weight-semibold(:value="totalAddonPrice")
  hr
  .box.branded-box
    h4.title.is-5 {{$t('services.details.consumable_products_label')}}
    p.subtitle.is-6(v-t="'inventory.product_type.consumable_include_in_service_description'")
    table.table.is-fullwidth
      thead
        tr
          th(v-t="'services.details.consumable'" style="width: 50%")
          //th.has-text-centered Fixed
          th.has-text-centered(v-t="'misc.required'")
          th(v-t="'services.details.default_qty'")
          //th Price
          th 
      tbody
        tr(v-if="consumables.length === 0")
          td.has-text-centered(colspan="4") {{$t('services.details.no_consumables')}}
        tr.is-vertically-centered(v-for="consumable in consumables" :key="consumable.product")
          td
            ProductView(:productId="consumable.product" :sku="true" price)
          td.has-text-centered
            b-checkbox(v-model="consumable.required" @input="update")
          //- td.has-text-right
          //-   currency-view()
          td
            b-field
              b-input(v-model="consumable.defaultQty" @input="update")
              p.control
                ProductUnitLabel.button.is-static(:product="consumable.product")
                
          td
            a(@click="remove(consumable)") 
              span.icon
                i.mdi.mdi-trash-can-outline.mdi-24px
      tfoot(v-if="consumables.length > 0")
        tr
          td.has-text-right(colspan="4") 
            span(v-t="'services.hard_costs_label'")  
            |  
            currency-view.has-text-weight-semibold(:value="totalHardcostsPrice")
        tr
          td.has-text-right(colspan="4") 
            span(v-t="'services.consumables_label'")   
            |  
            currency-view.has-text-weight-semibold(:value="totalConsumablesPrice")
  
  .buttons
    ProductSelector.is-rounded.is-primary.is-outlined(@input="onConsumableSelect" type="consumables")
      span.icon
        i.mdi.mdi-plus-circle-outline.mdi-24px
      span(v-t="'sale.actions.add_consumables'")
</template>
<script>
import ProductView from '../inventory/ProductView'
import ProductSelector from '../inventory/ProductSelector'
import ProductUnitLabel from '../inventory/ProductUnitLabel'
import PRODUCT_TYPES from '../../../constants/productTypes'
import cloneDeep from 'lodash/cloneDeep'
import {mapState} from 'vuex'
export default {
  name: 'ServiceHardCostEditor',
  components: {
    ProductView,
    ProductSelector,
    ProductUnitLabel
  },
  props: {
    value: {type: Array, default: () => []}
  },
  data() {
    return {
      items: []
    }
  },
  computed: {
    ...mapState('inventory', ['productsMap']),
    totalAddonPrice() {
      return this.addons.reduce((acc, addon) => {
        const product = this.productsMap[addon.product]
        if (!product) {
          return acc
        }
        return acc + addon.defaultQty * product.retailPrice * (addon.required ? 1 : 0)
      }, 0)
    },
    totalConsumablesPrice() {
      return this.consumables.reduce((acc, consumable) => {
        const product = this.productsMap[consumable.product]
        if (!product) {
          return acc
        }
        return acc + consumable.defaultQty * (product.retailPrice || 0) * (consumable.required ? 1 : 0)
      }, 0)
    },
    totalHardcostsPrice() {
      return this.consumables.reduce((acc, consumable) => {
        const product = this.productsMap[consumable.product]
        if (!product) {
          return acc
        }
        return acc + consumable.defaultQty * (product.supplyPrice || 0) * (consumable.required ? 1 : 0)
      }, 0)
    },
    consumables() {
      return this.items.filter(v => {
        const product = this.productsMap[v.product]
        if (!product) {
          return false
        }
        return product.type === PRODUCT_TYPES.CONSUMABLES && !product.isAddon
      })
    },
    addons() {
      return this.items.filter(v => {
        const product = this.productsMap[v.product]
        if (!product) {
          return false
        }
        return product.type === PRODUCT_TYPES.RETAIL || product.isAddon
      })
    }
  },
  watch: {
    value() {
      this.init()
    },
    addons() {
      this.$emit('totals', {
        addonsPrice: this.totalAddonPrice,
        consumablesPrice: this.totalConsumablesPrice,
        hardcostsPrice: this.totalHardcostsPrice
      })
    },
    consumables() {
      this.$emit('totals', {
        addonsPrice: this.totalAddonPrice,
        consumablesPrice: this.totalConsumablesPrice,
        hardcostsPrice: this.totalHardcostsPrice
      })
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.items = cloneDeep(this.value)
    },
    onConsumableSelect(product) {
      this.items.push({
        product: product._id,
        defaultQty: 1,
        required: false
        //isAddon: product.type === PRODUCT_TYPES.RETAIL || product.isAddon
      })
      this.update()
    },
    remove(consumable) {
      this.items.splice(this.items.indexOf(consumable), 1)
      this.update()
    },
    update() {
      this.$emit('input', this.items)
      this.$emit('totals', {
        addonsPrice: this.totalAddonPrice,
        consumablesPrice: this.totalConsumablesPrice,
        hardcostsPrice: this.totalHardcostsPrice
      })
    }
  }
}
</script>
